import { useMemo } from 'react';
import { useMeasure } from 'react-use';

export const breakpoints = {
    sm: 622, // 340
    md: 1080, // 740
    lg: 1470, //1030,
    xl: 1815, //1280,
};

export const useBreakpoints = () => {
    const [ref, bounds] = useMeasure();
    const { width } = bounds;
    const includedClasses = [];
    for (const [key, value] of Object.entries(breakpoints)) {
        if (width >= value) {
            includedClasses.push(key);
        } else {
            includedClasses.push(`down-${key}`);
        }
    }
    const classStr = includedClasses.join(' ');

    return useMemo(() => ({ ref, classStr }), [classStr]);
};
